import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    Toolbar,
    SaveButton,
    CardActions,
    ListButton,
    useNotify
} from 'react-admin';
import { Redirect } from 'react-router-dom';
import jwt_decode from 'jwt-decode'
import Exam from './Exam'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'

var userid = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).id : 0 ;

const useStyles = makeStyles({
    title :{
        display: 'inline-block',
        margin: '0px 20px 5px -10px',

        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },
    p: {
        fontSize: '12px',
    },
})

var exam_id = null;
var questions = null;
var answers = null;
var marks_per = null;
var passing_per = null;
var ispass = 0;

const setQuestions=(quests)=>(
    questions = quests
);

const setAnswers=(ans)=>(
    answers = ans
);

const setMarkPer=(marksper)=>(
    marks_per = marksper
);

const setPassingPer=(passingper)=>(
    passing_per = passingper
);

const setPass=(pass)=>(
    ispass = pass
);

const GetKey=({ props }) => (
    console.log(props),
    exam_id = (props.location)?((props.location.exam_id)?props.location.exam_id:exam_id):exam_id,
    userid = (props.location)?((props.location.user_id)?props.location.user_id:userid):userid,
    (exam_id)? '': <Redirect to={`/certifications?filter=%7B"user_id"%3A"${userid}"%7D&order=DESC&page=1&perPage=25&sort=id`} />
);

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
  };

const ExamActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        <ListButton basePath={`/certifications?filter=%7B"user_id"%3A"${userid}"%7D&order=DESC&page=1&perPage=25&sort=id`} label="Certification List" />
    </CardActions>
  );



const CreateToolbar = props => (

    <Toolbar {...props} >

        <SaveButton
            label="Submit"
            transform={data => ({
                ...data,
                exam_id: exam_id,
                questions: questions,
                answers: answers,
                marks_per: marks_per,
                passing_per: passing_per,
                ispass: ispass,
                user_id: (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).id : -1 ),
                exam_date: Date().toLocaleString(),
                last_updated: Date().toLocaleString()
            })
            }
            submitOnEnter={true}
            redirect={`/`}
        />
    </Toolbar>
);

const ExamHeader=({props})=>{
    const classes = useStyles();
    return(
        <div className={classes.title}>
            <h2>{(props.location)?((props.location.exam_name)?props.location.exam_name:'Exam'):'Exam'}</h2>
            <p className={classes.p}>
                {((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).full_name : null }&nbsp;&nbsp;&nbsp;&nbsp;
                {moment(Date()).format('MM/DD/yyyy')}</p>
        </div>
    )
}

const ExamlogCreate = ({...props }) => (
    <Create
        title={(props.location)?((props.location.exam_name)?props.location.exam_name:'Exam'):'Exam'}

        {...props}
    >
        <SimpleForm   toolbar={<CreateToolbar />} >
        <ExamHeader props={props} />
        <Exam
            examid={(props.location)?((props.location.exam_id)?props.location.exam_id:exam_id):exam_id}
            setQuestions={setQuestions}
            setAnswers={setAnswers}
            setMarkPer={setMarkPer}
            setPassingPer={setPassingPer}
            setPass={setPass}
            props={props}
        />
        <GetKey props={props} />
        </SimpleForm>
    </Create>
)

export default ExamlogCreate;